var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-popup',{model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('img',{staticClass:"auth-qrcode",attrs:{"src":_vm.qrCode,"alt":""}}),_c('div',{staticClass:"auth-tips"},[_vm._v("请用支付宝扫一扫")])])}
var staticRenderFns = []

export { render, staticRenderFns }